import {BILLING_CYCLE} from "@/common/constants";
import {getBasePlansFrom} from "@/common/product";
import {plansof} from "@/utils/chain";
import {planTypes} from "@zoom/billing-payment";
import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters(['getSelectedPlans']),
    mx_autofill_billingCycleRadioGroups() {
      return this.mx_autofill_ensure_is_billing_cycle_group(Array.from(this.$el.querySelectorAll('.zm-radio-group')))
    }
  },
  methods: {
    mx_autofill_ensure_is_billing_cycle_group(radioGroups) {
      const otherBillingCycles = {
        CMR_MONTHLY_COMMITMENT_10: 'cmr_monthly_commitment_10',
        CMR_200GB_MONTHLY: 'cmr_200GB_monthly',
        CMR_1TB_MONTHLY: 'cmr_1TB_monthly',
        CMR_5TB_MONTHLY: 'cmr_5TB_monthly',
        ZTRANSL_MONTHLY: 'ztransl_monthly',
        ZTRANSL_YEARLY: 'ztransl_yearly',
        ZE_AH_MONTHLY: 'ze_ah_monthly',
        ZE_AH_YEARLY: 'ze_ah_yearly',
        ZE_ACE_MONTHLY: 'ze_ace_monthly',
        ZE_ACE_YEARLY: 'ze_ace_yearly',
        ZEC_AH_MONTHLY: 'zec_ah_monthly',
        ZEC_AH_YEARLY: 'zec_ah_yearly',
        ZEC_ACE_MONTHLY: 'zec_ace_monthly',
        ZEC_ACE_YEARLY: 'zec_ace_yearly'
      }
      const billingCycleValues = Object.values(BILLING_CYCLE).concat(Object.values(otherBillingCycles));
      return radioGroups?.filter((group) => {
        const radioInput = group.querySelector('input[type=radio]');
        const radio = group.querySelector('.zm-radio')
        const cycle = radio.getAttribute('data-billing_cycle') || radioInput.getAttribute('value');
        return billingCycleValues.includes(cycle);
      })
    },
    mx_autofill_billingCycle() {
      const basePlan = getBasePlansFrom(this.getSelectedPlans);
      const billingCycle = basePlan?.[0]?.billing_cycle;

      function dealEachPlanCircle(radioGroups) {
        if (!radioGroups) return;

        const radios = Array.from(radioGroups.querySelectorAll('.zm-radio input[type=radio]'));
        if (radios.length === 0) return;
        // If any radio is already checked, do nothing
        if (radios.some(radio => radio.checked)) return;

        // Filter out radios that are disable
        const availableRadios = radios.filter(radio => !radio.disabled);
        if (availableRadios.length === 0) return;

        const internalToCycleMap = {
          monthly: ['ztransl_monthly', 'ze_ah_monthly', 'ze_ace_monthly', 'zec_ah_monthly', 'zec_ace_monthly'],
          annual: ['ztransl_yearly', 'ze_ah_yearly', 'ze_ace_yearly', 'zec_ah_yearly', 'zec_ace_yearly'],
        };

        const pickByValue = value => {
          const candidates = internalToCycleMap[value];
          let selectedRadio = null
          if (candidates?.length) {
            selectedRadio = availableRadios.find(radio => candidates.includes(radio.value))
          }
          if (!selectedRadio) {
            selectedRadio = availableRadios.find(radio => {
              return radio.value === value
            });
          }
          return selectedRadio
        };

        // Priority: try exact billingCycle → annual → monthly → fallback to first available
        const targetRadio = pickByValue(billingCycle)
          || pickByValue('annual')
          || pickByValue('monthly')
          || availableRadios[0];

        targetRadio?.click();
      }

      if (!this.mx_autofill_billingCycleRadioGroups.length) return
      for (let i = 0; i < this.mx_autofill_billingCycleRadioGroups.length; i++) {
        dealEachPlanCircle(this.mx_autofill_billingCycleRadioGroups[i])
      }
    },
  },
  mounted() {
    const isAllowed = this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.add2cart;
    if (!isAllowed) return;
    this.$nextTick(() => {
      try {
        // make sure we don't have this type selected already
        const type = planTypes[this.$options.key];
        if (plansof(this.getSelectedPlans).type(type).has()) return;
        this.mx_autofill_billingCycle()
      } catch (e) {
        console.log(e)
      }
    });
  },
}
